export { default as CafeVirtuelPage } from './CafePage'
